v<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'
import Vue from 'vue'

import { customerEndpointApi } from '@router/apiFiles/customerEndpointApi'

export default {
	page: {
		title: 'Customer endpoint search',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			tableData: [],
			isBusy: true,
			title: 'Customer endpoint search',
			items: [
				{
					text: 'OnBoard',
					href: '/',
				},
				{
					text: 'Customer Endpoint',
					href: '/',
				},
				{
					text: 'Search',
					active: true,
				},
			],
			filter: '',
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			fields: [
				'link',
				'Endpoint',
				'Customer'
			],
		}
	},
	computed: {
		/**
		 * Total no. of records
		 */
		rows() {
			return this.tableData.length
		},
	},
	mounted() {
		this.fetchData().catch(error => {
		    console.error(error)
		})
	},
	methods: {
		
		/**
		 * Search the table data with search input
		 */
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			//this.totalRows = filteredItems.length
			//this.currentPage = 1
			//console.log(filteredItems);
		},
        async fetchData() {
			var self = this;
			customerEndpointApi.searchCustomerEndpoints({ search: self.filter, page: self.currentPage, perPage: self.perPage })
				.then(function (data) {
					self.tableData = data.data;
					self.isBusy = false;
					self.totalRows = data.totalItems;
				});
		},		
	},
	watch: {
	    currentPage: {
	        handler: function (value) {
	            this.fetchData().catch(error => {
	                console.error(error)
	            })
	        }
		},
        perPage: {
            handler: function (value) {
                this.fetchData().catch(error => {
                    console.error(error)
                })
            }
        }
	}
}
</script>
<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<p class="text-muted font-13 mb-4"></p>
						<div class="row mb-md-2">

							<!-- Search -->
							<div class="col-sm-6 col-md-4">
								<div>
									<label class="">
										Search:
									</label>
									<b-input-group>
										<b-form-input v-model="filter"
													  type="search"
													  placeholder="name..."
													  class="form-control form-control-sm"></b-form-input>
										<b-input-group-append>
											<b-button variant="info" @click="fetchData" class="pb-0 pt-0 pl-1 pr-1"><i class="uil uil-search "></i></b-button>
										</b-input-group-append>
									</b-input-group>
								</div>
							</div>
							<!-- End search -->

							<div class="col-sm-6 col-md-4">
								<div id="tickets-table_length" class="dataTables_length  text-md-right">
									<label class="d-inline-flex align-items-center">
										Show&nbsp;
										<b-form-select v-model="perPage"
													   size="sm"
													   :options="pageOptions"></b-form-select>&nbsp;entries
									</label>
								</div>
							</div>
						</div>
					

						<!-- Table -->
						<div class="table-responsive mb-0">
							<b-table :items="tableData"
									 :fields="fields"
									 responsive="sm"
									 :per-page="0"
									 :current-page="currentPage"
									 :busy="isBusy">
								<template #table-busy>
									<div class="text-center text-danger my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>
								</template>
								<template #cell(link)="data">
									<router-link tag="a" :to="`/customerendpoint/${data.item.id}`"><b>{{ data.item.name }}</b></router-link>
								</template>
								<template #cell(Endpoint)="data">
									<span>{{ data.item.endpoint }}</span>
								</template>
								<template #cell(Customer)="data">
									<span>{{ data.item.customerName }}</span>
								</template>
							</b-table>
						</div>
						<div class="row">
							<div class="col">
								<div
									class="dataTables_paginate paging_simple_numbers float-right"
								>
									<ul class="pagination pagination-rounded mb-0">
										<!-- pagination -->
										<b-pagination
											v-model="currentPage"
											:total-rows="totalRows"
											:per-page="perPage"
										></b-pagination>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
